import { T } from '@tribeplatform/react-components/i18n'
import { Alert } from '@tribeplatform/react-ui-kit/Alert'

interface Props {
  planName: string
}

export const UpgradeSuccessAlert = ({ planName }: Props) => {
  return (
    <Alert status="success" className="font-semibold">
      <T
        defaultMessage="Congratulations! You've successfully upgraded to the {planName} plan."
        id="Admin.Billing.SubscribedToPlan"
        values={{ planName }}
      />
    </Alert>
  )
}
